import { render, staticRenderFns } from "./MfaEnable.vue?vue&type=template&id=5423fcfc&scoped=true"
import script from "./MfaEnable.vue?vue&type=script&lang=js"
export * from "./MfaEnable.vue?vue&type=script&lang=js"
import style0 from "./MfaEnable.vue?vue&type=style&index=0&id=5423fcfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5423fcfc",
  null
  
)

export default component.exports